import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PermissionService {

    permissions:any = [];
    modules:any = [];
    constructor(private localStorage:LocalStorageService,private auth:JWTTokenServiceService) {
      this.refresh();
    }

  refresh(): void {
    if(this.auth.getToken())
    {
      this.permissions = JSON.parse(this.localStorage.getPermissions()); 
      const fm = this.localStorage.getFeatureModules();
      this.modules = fm ? fm.split(',').map((s: string) => s.trim().toLowerCase()) : [];
    }
  }

  getfeatureAccess(module_name: any, feature_name: any): boolean {

  // console.log("module_name", module_name);
  // console.log("feature_name", feature_name);

  const module = this.permissions.find(
    (item: any) => item.module_name === module_name
  );

  // console.log("permissions", module);

  if (!module || !module.active) return false;

  // 🔥 Normalize function
  const normalize = (val: string) =>
    (val || '')
      .toLowerCase()
      .replace(/[\s-]/g, '_')   // space & dash → underscore
      .trim();

  const normalizedFeature = normalize(feature_name);

  const feature = module.features?.find(
    (item: any) =>
      normalize(item.name) === normalizedFeature &&
      item.active === true
  );

  return !!feature;
}
 getAccess(module_name:any)
 {
  let result = this.permissions.filter((item:any)=>{
   return  item.module_name  == module_name && item.active == true;
  })
  return (result[0]) ? true : false;
 } 
  getFeatureModuleAccess(module_name: any): boolean
  {
    const normalized = (module_name || '').toLowerCase().replace(/-/g, '_');
    return this.modules.includes(normalized);
  }

  hasModuleAccess(module: string): boolean {
    return this.getAccess(module);
  }

  hasChildAccess(module: string, child: any): boolean {
    return this.getfeatureAccess(module, child);
  }
}